const firebaseConfig = {
  apiKey: "AIzaSyD0KuwFQ77-t6jVDQxqZj-llIiu3FZ0JBI",
  authDomain: "collar-app.firebaseapp.com",
  databaseURL: "https://collar-app.firebaseio.com",
  projectId: "collar-app",
  storageBucket: "collar-app.appspot.com",
  messagingSenderId: "828930806626",
  appId: "1:828930806626:web:c824e08453a107b4a9123b",
  measurementId: "G-6QE32TX3CP",
}

let firebaseAuthPromise

async function getFirebaseAuth() {
  if (!firebaseAuthPromise) {
    firebaseAuthPromise = Promise.all([
      import("firebase/app"),
      import("firebase/auth"),
    ]).then(([appSdk, authSdk]) => {
      const app = appSdk.getApps().some(({ name }) => name === "[DEFAULT]")
        ? appSdk.getApp()
        : appSdk.initializeApp(firebaseConfig)

      return { auth: authSdk.getAuth(app), authSdk }
    })
  }

  return firebaseAuthPromise
}

export async function signInWithGoogle() {
  const { auth, authSdk } = await getFirebaseAuth()
  const provider = new authSdk.GoogleAuthProvider()
  const result = await authSdk.signInWithPopup(auth, provider)
  return result.user
}

export async function observeGoogleUser(onUserChanged) {
  const { auth, authSdk } = await getFirebaseAuth()
  return authSdk.onAuthStateChanged(auth, onUserChanged)
}
